import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createDemoCredentials } from './DemoCredentialCreateApi';

export interface DemoCredentialState {
    pidJson: string;
    created: string[];
    error?: string;
}

const formatJson = (s: string): string => {
    try { return JSON.stringify(JSON.parse(s), null, 2); } catch { return s; }
};

const SAMPLE_PID_JSON = JSON.stringify({
    vct: 'Pid',
    family_name: 'Jansma',
    given_name: 'Klaas',
    birth_date: '1975-11-01',
    family_name_birth: 'Jansma',
    given_name_birth: 'Klaas',
    birth_place: 'Leeuwarden',
    birth_country: 'Netherlands',
    birth_state: 'Friesland',
    birth_city: 'Leeuwarden',
    resident_address: 'Torenstraat 78',
    resident_country: 'Netherlands',
    resident_state: 'Friesland',
    resident_city: 'Leeuwarden',
    resident_postal_code: '8911 BS',
    resident_street: 'Torenstraat',
    resident_house_number: '78',
    gender: 'Male',
    nationality: 'Dutch',
    document_number: 'GHI345678',
    administrative_number: '1732203412',
    issuing_country: 'Netherlands',
    issuing_jurisdiction: 'NL-FR',
    age_over_18: true,
    age_over_21: true,
    age_in_years: 49,
    age_birth_year: 1975,
}, null, 2);

const initialState: DemoCredentialState = {
    pidJson: SAMPLE_PID_JSON,
    created: [],
};

export const demoCredentialSlice = createSlice({
    name: 'demoCredential',
    initialState,
    reducers: {
        setPidJson(state, action: PayloadAction<string>) {
            state.pidJson = action.payload;
        },
        resetDemoCredential(state) {
            state.pidJson = SAMPLE_PID_JSON;
            state.created = [];
            state.error = undefined;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(createDemoCredentials.fulfilled, (state, { payload }) => {
                state.created = payload;
                state.error = undefined;
            })
            .addCase(createDemoCredentials.rejected, (state, { error }) => {
                state.error = error.message;
            });
    },
});

export const { setPidJson,  resetDemoCredential } = demoCredentialSlice.actions;
export const demoCredentialReducer = demoCredentialSlice.reducer;
export const demoCredentialSelector = (s: { demoCredentialState: DemoCredentialState }) => s.demoCredentialState;
